<template lang="pug">
modal(name="email-force-input-modal" :title="modalTitle" :closable="closable")
  .modal-email
    .modal-email-message(v-if="message" v-html="message")
    form(@submit.prevent="updateEmail")
      div
        .modal-email-ttl(v-if="this.$auth.loggedIn && this.emailRegistered")
          | 新しいメールアドレス
        input(type="email" v-model="email" autocomplete="email" placeholder="メールアドレス")
      div(align="center")
        input.c-btn(type="submit" value="メールアドレスを登録する" :disabled="!submittable()")
</template>

<script>
import Modal from './Modal'

export default {
  components: {
    Modal
  },
  props: {
    closable: {
      type: Boolean,
      default: false
    },
    fastView: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      email: null,
      message: null,
      loading: false
    }
  },
  computed: {
    emailRegistered() {
      return !this.$auth.user.email.endsWith('@example.com')
    },
    modalTitle() {
      if (this.$auth.loggedIn && this.emailRegistered) {
        return 'メールアドレスの変更'
      } else if (this.title) {
        return this.title
      } else {
        return 'ご利用にはメールアドレスの登録が必要です'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.fastView && this.$auth.loggedIn && !this.emailRegistered) {
        this.$cookies.set('afterLoginURL', this.$route.fullPath)
        this.$modal.show('email-force-input-modal')
      }
    })
  },
  methods: {
    submittable() {
      return !!this.email && !this.loading
    },
    updateEmail() {
      this.loading = true
      this.$axios
        .patch('/mypage/email', {
          email: this.email
        })
        .then(() => {
          this.message =
            '本人確認用のメールを送信しました。<br>メール内のリンクからアカウントを有効化させてください。'
        })
        .catch(({ response }) => {
          const message = response.data.email
            .map((message) => {
              return `メールアドレス${message}。`
            })
            .join('<br>')
          this.message = message
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss">
.modal-email {
  @include media(pc) {
    min-width: 430px;
  }
  &-message {
    font-size: 16px;
    color: $blue;
    margin-bottom: 10px;
    line-height: 1.5;
    @include media(sp) {
      font-size: 14px;
    }
  }
  &-ttl {
    font-weight: bold;
    margin-bottom: 10px;
  }
  div + div {
    margin-top: 10px;
  }
  input[type='email'] {
    width: 100%;
    padding: 0 15px;
    line-height: 42px;
  }
  input[type='submit'] {
    font-size: 15px;
    @include media(sp) {
      width: 100%;
    }
  }
}
</style>
